import Card from "components/card";

// Kuest admin stat tile: label text-sm muted, value semibold tabular-nums.
// The value never wraps inside a number; its size follows the tile's width
// (container query units, capped at text-2xl) so long amounts fit on one line.
const Widget = ({ icon, title, subtitle }) => {
  return (
    <Card extra="flex-grow p-5">
      <div className="absolute right-5 top-5 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-border bg-muted/35 text-muted-foreground [&>svg]:h-5 [&>svg]:w-5">
        <span className="flex items-center [&>svg]:h-5 [&>svg]:w-5">{icon}</span>
      </div>
      <p className="min-h-[2.5rem] pr-12 text-sm font-medium text-muted-foreground">{title}</p>
      <div className="mt-1 min-w-0 [container-type:inline-size]">
        <h4 className="num overflow-hidden text-ellipsis whitespace-nowrap text-[clamp(1rem,10.5cqi,1.5rem)] font-semibold leading-tight text-foreground">
          {subtitle}
        </h4>
      </div>
    </Card>
  );
};

export default Widget;
